import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { EntityForm } from "@/components/v2/entity-form";
import { useCreateTeamMember } from "@/hooks/use-api";
import {
  TEAM_MEMBER_FIELDS,
  type TeamMemberFormValues,
} from "./team-member-form-config";

export default function V2TeamMemberCreatePage() {
  const navigate = useNavigate();
  const createTeamMember = useCreateTeamMember();
  const [error, setError] = useState<string | null>(null);

  async function onSubmit(values: TeamMemberFormValues) {
    setError(null);
    try {
      const { team_member } = await createTeamMember.mutateAsync(values);
      const contactId = (team_member as Record<string, unknown> | undefined)
        ?.contact_id;
      if (!contactId) {
        setError("Unexpected response from the server — please try again.");
        return;
      }
      toast.success("Team member created");
      navigate(`/team-members/${contactId}`);
    } catch (err) {
      setError(
        err instanceof Error
          ? err.message
          : "Could not create the team member — check the fields and try again.",
      );
    }
  }

  return (
    <EntityForm<TeamMemberFormValues>
      title="Create team member"
      breadcrumbs={[
        { label: "Team members", href: "/team-members" },
        { label: "New" },
      ]}
      defaultValues={{}}
      fields={TEAM_MEMBER_FIELDS}
      submitLabel="Create team member"
      onSubmit={onSubmit}
      cancelHref="/team-members"
      error={error}
      isSubmitting={createTeamMember.isPending}
    />
  );
}
